<template>
    <div class="dataStatistics">
        <div class="title-box title-box-ipt">
            <div class="left-nox-t">
                <img class="cion" src="@/assets/home/dateLeft-icon.png" />
                <span>农家乐</span>
            </div>
            <el-input class="ipt" placeholder="请输入" v-model="iptVal" @change="changeVal" />
        </div>
        <div class="dataStatistics-box">
            <el-table
                ref="table"
                :data="list"
                class="tableBox"
                :row-class-name="tableRowClassName"
                :max-height="340"
                v-loading="loading"
                :show-header="false"
                style="width: 100%"
            >
                <el-table-column type="index" align="center" width="50" />
                <el-table-column prop="name" label="">
                    <template #default="scope">
                        <span style="cursor: pointer;" @click="bindName(scope.row)">{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column width="160">
                    <template #default="scope">
                        <span>今日入住：{{ scope.row.todayCheckInCount }}人</span>
                    </template>
                </el-table-column>
                <el-table-column width="170">
                    <template #default="scope">
                        <span>今日空房间： {{ scope.row.remainRoom || 0 }}间</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <DataWZD ref="wzdDialog" />
    </div>
</template>

<script>
import DataWZD from "./DataWZD";

export default {
    data() {
        return {
            loading: false,
            iptVal: '',
        };
    },
    components: {
        DataWZD,
    },
    props: {
        list: {
            type: Array,
            default: () => [],
        },
    },
    mounted() {
        this.$nextTick(() => {
            const tableBodyWrapper = this.$refs.table?.$el?.querySelector('.el-table__body-wrapper');
            if (tableBodyWrapper) {
                tableBodyWrapper.addEventListener('scroll', this.handleTableScroll);
            }
        });
    },
    beforeDestroy() {
        const tableBodyWrapper = this.$refs.table?.$el?.querySelector('.el-table__body-wrapper');
        if (tableBodyWrapper) {
            tableBodyWrapper.removeEventListener('scroll', this.handleTableScroll);
        }
    },
    methods: {
        changeVal(e) {
            this.$emit('changeVal', e);
        },
        tableRowClassName({ rowIndex }) {
            return rowIndex % 2 === 0 ? 'even-row' : '';
        },
        bindWzd(row) {
            this.$refs.wzdDialog.init(row);
        },
        bindName(row) {
            this.$emit('bindName', row);
        },
        handleTableScroll(e) {
            const { scrollTop, scrollHeight, clientHeight } = e.target;
            const isBottom = scrollTop + clientHeight >= scrollHeight - 1;
            if (isBottom) {
                this.onReachBottom();
            }
        },
        onReachBottom() {
            console.log('滚动到底部了');
            this.$emit('scrollEnd');
        },
    },
};
</script>

<style lang="scss" scoped>
    /* @import "../../../assets/scss/index.scss"; */

    .dataStatistics {
        margin-bottom: 10px;
        /* background-image: url(../../../assets/home/bg-2.png); */
        background: linear-gradient(180deg, rgba(32, 65, 116, .3) 0%, rgba(113, 161, 246, .3) 100%);
        background-size: 100% 100%;
        margin-bottom: 10px;

        .title-box {
            width: 100%;
            height: 42px;
            background-image: url(../../../assets/home/title-box-bg.png);
            background-size: 100% 100%;
            font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
            font-weight: bold;
            font-size: 16px;
            color: #FFFFFF;
            display: flex;
            align-items: center;

            .cion {
                width: 34px;
                height: 35px;
                margin-right: 10px;
            }
        }

        .title-box-ipt {
            display: flex;
            justify-content: space-between;
            .left-nox-t {
                display: flex;
                flex-shrink: 0;
                align-items: center;
            }
            ::v-deep .ipt {
                flex: 0.4;
                background: none;
                .el-input__inner {
                    background: none !important;
                    color: #fff !important;
                    border: 1px solid #409eff;
                }
            }
        }

        .dataStatistics-box {
            width: 100%;
            padding-top: 10px;
            height: 360px;


        }

        ::v-deep .tableBox {
            background: none;

            tr {
                background: none;

                th {
                    background: none;
                    color: #9FD9FF;
                }

                td {
                    border: none;
                    border-bottom: 1px solid #4A72A2;
                    border-left: none;
                    border-right: none;
                }
            }

            .has-gutter {
                border: 1px solid #9FD9FF;
            }

            .el-table__header-wrapper {
                border: 1px solid #9FD9FF;
            }

            .is-leaf {
                border: none;
            }

            .el-table__row {

                /* border: 1px solid #4A72A2; */
            }

            .el-table__cell {
                /* border: none; */
                border-left: none;
                border-right: none;
            }

            .el-table__header-wrapper {
                background: linear-gradient(180deg, #02265B 0%, #34639A 100%);
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: normal;
                font-size: 18px;
                color: #9FD9FF;
            }

            .el-table__row:nth-child(2n) {
                background: linear-gradient(180deg, #1F4277 0%, #34639A 100%);
            }

            .el-table__row {
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: normal;
                font-size: 18px;
                color: #BFDDFF;
            }

            .even-row {
                background: none !important;

            }

            .el-table__row:hover {
                background: none !important;
                /* 设置悬停时的背景色 */
            }


        }

        ::v-deep .el-table::before {
            background: none;
        }

        /* 鼠标移入某一行的样式 */
        ::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
            background: linear-gradient(180deg, #1F4277 0%, #34639A 100%);
        }

        ::v-deep .el-table__body tr.current-row>td.el-table__cell {
            background-color: #409eff;
        }

        .btn {
            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;

        }

        /* 自定义图标 */
        /* 表格上的 */
        .tableIcon {
            display: inline-block;
            width: 20px !important;
            height: 29px !important;
            background-image: url(../../../assets/home/table-icon.png);
            background-size: 100% 100%;
        }

        ::v-deep .dialogQy {
            background: linear-gradient(180deg, #02265B 0%, #34639A 100%);
            border: 1px solid #4A72A2;

            .el-dialog__header {
                padding: 0;
            }

            .el-dialog__body {
                padding: 10px;
            }

            .title-view {
                width: 45%;
                margin: 0 auto;
            }

            .dialog_title_tet {
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: normal;
                font-size: 12px;
                color: #FFFFFF;
                margin-bottom: 10px;

                .flex_title {
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .fengexian {
                        width: 20px;
                        height: 1px;
                        background-color: #CBE2F6;
                    }

                    .title_tet {
                        margin: 0 10px;
                    }
                }

            }

            .deatl {
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: normal;
                font-size: 12px;
                color: #FFFFFF;
                line-height: 18px;
            }

            .el-dialog__footer {
                padding-bottom: 10px;
            }

            .dialog-footer {

                .footer-btn {
                    width: 116px;
                    border-radius: 0;
                    background: linear-gradient(180deg, #1F4277 0%, #34639A 100%);
                    border: 1px solid #9FD9FF;
                    font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                    font-weight: normal;
                    font-size: 14px;
                    color: #9FD9FF;
                }
            }
        }






    }
</style>